import React from 'react'
import { Link } from 'react-router-dom'
export default function development() {
    return (
        <>
        
            <main>

                <div className="hero-arera course-item-height" data-background="assets/img/slider/course-slider.jpg" style={{ backgroundImage: " url(assets/img/slider/mobile-phone.avif)" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="hero-course-1-text">
                                    <h2> Development Course </h2>
                                </div>
                                <div className="course-title-breadcrumb">
                                    <nav>
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                            <li className="breadcrumb-item"><span>Courses</span></li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        <div className="container">
        
                <div className="row" style={{marginTop:"2rem"}}>
                    <div className="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-12 col-sm justify-content-center mb-30">
                        <div className="section-title mb-20 text-center">
                            <h2>Choose your favorite <span className="down-mark-line">courses </span></h2>
                        </div>
                    </div>
                </div>

                </div>



                <section className="course-content-area pb-90 mt-5">
                    <div className="container">
                        <div className="row mb-10">


                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development">
                                                    <img src="assets/img/course/course-01.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>WordPress Development Course for Plugins & Themes</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                               <Link className="edo-course-sec-btn" target='_blank'  to="https://wa.me/9617124507">Apply now</Link>
                                                         
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                        {/* <del>$24.50</del> */}
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">WordPress Development Course for Plugins & Themes</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div  className="eduman-course-footer">
                   
                      <div  className="course-deteals-btn">
                      <Link className="edo-course-sec-btn text-light" style={{color:"white"}} target='_blank'  to="https://wa.me/9617124507">Apply Now
                               </Link>
                      </div>
                   </div>
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>



                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-06.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Basics for Beginners: Learn C & C++ Fundamentals by
                                                                Coding</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                               <Link className="edo-course-sec-btn" target='_blank'  to="https://wa.me/9617124507">Apply now</Link>
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Basics for Beginners: Learn C & C++ Fundamentals by
                                                            Coding</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div  className="eduman-course-footer">
                   
                   <div  className="course-deteals-btn">
                   <Link className="edo-course-sec-btn text-light" style={{color:"white"}} target='_blank'  to="https://wa.me/9617124507">Apply Now
                            </Link>
                   </div>
                </div>
                                                </div>
                                            </div>
                                         
                                        </div>
                                    </div>




                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-11.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Basics for Beginners: Learn Scratch to HTML & Css </h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                               <Link className="edo-course-sec-btn" target='_blank'  to="https://wa.me/9617124507">Apply now</Link>
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Basics for Beginners: Learn Scratch to HTML & Css 
                                                           </Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div  className="eduman-course-footer">
                   
                   <div  className="course-deteals-btn">
                   <Link className="edo-course-sec-btn text-light" style={{color:"white"}} target='_blank'  to="https://wa.me/9617124507">Apply Now
                            </Link>
                   </div>
                </div>
                                                </div>
                                            </div>
                                         
                                        </div>
                                    </div>





                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-14.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Understanding Java Script  & jQuery Development </h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                               <Link className="edo-course-sec-btn" target='_blank'  to="https://wa.me/9617124507">Apply now</Link>
                                                       
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Understanding Java Script  & jQuery Development</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div  className="eduman-course-footer">
                   
                   <div  className="course-deteals-btn">
                   <Link className="edo-course-sec-btn text-light" style={{color:"white"}} target='_blank'  to="https://wa.me/9617124507">Apply Now
                            </Link>
                   </div>
                </div>
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>
                                  

                             




                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-04.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>MySQL Database : Beginner SQL Database Design</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                               <Link className="edo-course-sec-btn" target='_blank'  to="https://wa.me/9617124507">Apply now</Link>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>

                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">MySQL Database : Beginner SQL Database Design</Link>
                                                        </h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div  className="eduman-course-footer">
                   
                   <div  className="course-deteals-btn">
                   <Link className="edo-course-sec-btn text-light" style={{color:"white"}} target='_blank'  to="https://wa.me/9617124507">Apply Now
                            </Link>
                   </div>
                </div>
                                                </div>
                                            </div>
                                         
                                        </div>
                                    </div>
                                  
                                   
                                
                                  
                                  
                                    <div className="col-xl-4 col-lg-6 col-md-6">
                                        <div className="protfolio-course-2-wrapper mb-30">
                                            <div className="student-course-img">
                                                <Link to="/Development"><img src="assets/img/course/course-12.jpg"
                                                    alt="course-img" /></Link>
                                            </div>
                                            <div className="course-cart">
                                                <div className="course-info-wrapper">
                                                    <div className="cart-info-body">
                                                        <span className="category-color category-color-1"><Link
                                                            to="/Development">Development</Link></span>
                                                        <Link to="/Development">
                                                            <h3>Basics for Beginners: Learn Scratch to PHP Development</h3>
                                                        </Link>
                                                        <div className="cart-lavel">
                                                            <h5>Level : <span>Beginner</span></h5>
                                                            <p>Knowledge is power. Information is liberating. Education is the premise of
                                                                progress, in every society, in every family</p>
                                                        </div>
                                                        <div className="info-cart-text">
                                                            <ul>
                                                                <li><i className="far fa-check"></i>Scratch to HTML</li>
                                                                <li><i className="far fa-check"></i>Learn how to code in Python</li>
                                                                <li><i className="far fa-check"></i>Unlimited backend database creation</li>
                                                                <li><i className="far fa-check"></i>Adobe XD Tutorials</li>
                                                            </ul>
                                                        </div>
                                                        <div className="course-action">
                                                               <Link className="edo-course-sec-btn" target='_blank'  to="https://wa.me/9617124507">Apply now</Link>
                                                       
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="portfolio-course-2-content">
                                                <div className="portfolio-course-wrapper">
                                                    <div className="portfolio-price">
                                                        <span>20%</span>
                                                    </div>
                                                    <div className="portfolio-course-2">
                                                        <h3><Link to="/Development">Basics for Beginners: Learn Scratch to PHP Development</Link></h3>
                                                    </div>
                                                    <div className="course-icon">
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fas fa-star"></i>
                                                        <i className="fal fa-star"></i>
                                                        <span>(25)</span>
                                                    </div>
                                                    <div  className="eduman-course-footer">
                   
                   <div  className="course-deteals-btn">
                   <Link className="edo-course-sec-btn text-light" style={{color:"white"}} target='_blank'  to="https://wa.me/9617124507">Apply Now
                            </Link>
                   </div>
                </div>
                                                </div>
                                            </div>
                                        
                                        </div>
                                    </div>
                                 
                                </div>



                         
                            </div>
                        </div>
                    </div>
                </section>

            </main>



        </>
    )
}
